<template>
  <div>
    <el-dialog
      custom-class="real-dialog"
      :title="titleDialog"
      :visible="dialogVisible"
      width="500px"
      @close="handleClose"
      center
      append-to-body
    >
      <el-form :model="form" ref="form" :rules="rules" label-width="100px">
        <!--
        <el-form-item label="车牌颜色" prop="PlateColor">
          <el-select v-model="form.PlateColor" :disabled="noPlateNumber">
            <el-option
              v-for="(item, index) in plateColorArr"
              :key="index"
              :value="index + 1"
              :label="item"
            >
            </el-option>
          </el-select>
        </el-form-item>-->
        <el-form-item label="车牌号码" :prop="noPlateNumber ? '' : 'PlateNumber'">
          <el-col :span="18">
            <plate-input
              class="handleIn"
              :data.sync="form.PlateNumber"
              :visible.sync="dialogPlateVisible"
              @ok="getPlateNumber"
              @cancel="getPlateNumber"
            >
              <el-input
                style="width: 217px;"
                :autofocus="true"
                :disabled="noPlateNumber"
                v-model="form.PlateNumber"
                @focus="dialogPlateVisible = true"
              />
            </plate-input>
            <!--
            <plate-panel
                    :dialogVisible="dialogVisible"
                    :noPlateNumber="noPlateNumber"
                    @ok="getPlateNumber"
            ></plate-panel>-->
          </el-col>
          <el-col :span="4">
            <el-checkbox v-model="noPlateNumber" @change="handleCheck">无牌车</el-checkbox>
          </el-col>
        </el-form-item>
        <el-form-item label="车辆类型" prop="CarSize">
          <car-size-select
            ref="carSizeSelect"
            v-model="form.CarSize"
            @change="getCarSize"
          ></car-size-select>
        </el-form-item>
        <el-form-item label="开闸车道" style="width: 100%" prop="ParkLotGateId">
          <gateSelect
            ref="item"
            @change="getItem"
            :selectKey="'Id'"
            :Direction="0"
            v-model="form.ParkLotGateId"
            :isDisabled="selectDisabled"
          />
        </el-form-item>
        <el-form-item label="入场时间" prop="PassTime" v-if="titleDialog === '强制入车'">
          <el-date-picker
            v-model="form.PassTime"
            type="datetime"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="出场类型" v-if="false">
          <el-select v-model="form.Source">
            <el-option
              v-for="(v, i) in statusOptions"
              :key="i"
              :value="v.Id"
              :label="v.TypeName"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开闸原因">
          <el-input v-model="form.Remark"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="warning" @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleClick" :disabled="isDisabled">开 闸</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// import platePanel from "./platePanel";
import showdialog from "@/minxs/showdialog";
import plateMix from "@/minxs/parkLotId";
import { openGate, outPassType } from "@/api/module/park";
import gateSelect from "@/serviceComponents/gateSelect";
import { eventPubSub } from "@/service/pubsub/index";
import carSizeSelect from "@/serviceComponents/carSizeSelect";
import plateInput from "@/components/PlateInput/index";

export default {
  components: {
    // platePanel,
    gateSelect,
    carSizeSelect,
    plateInput,
  },
  props: {
    videoGateId: {
      type: Number,
      default: -1
    },
    selectDisabled: {
      type: Boolean,
      default: false
    },
    titleDialog: {
      type: String,
      default: '强制入车'
    }
  },
  mixins: [showdialog, plateMix],
  computed: {
    gateId: function () {
      let arr = this.$store.state.order.gateIds ? this.$store.state.order.gateIds : [];
      let id = arr[0] ? arr[0].Id : undefined;
      return id;
    },
  },
  watch: {
    gateId: function (newV) {
      this.form.ParkLotGateUuid = newV;
    },
    videoGateId(v) {
      this.form.ParkLotGateUuid = v;
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.gateId) {
        this.form.ParkLotGateId = this.videoGateId > -1 ? this.videoGateId :this.gateId;
        // this.form.ParkLotGateUuid = this.gateId;
        this.$refs.item.server(true);
        this.$refs.carSizeSelect.server(true);
        this.form.PassTime = this.formatDateTime(new Date());
        // this.outPassType();
        this.form.Direction = this.titleDialog === '强制入车' ? 1 : 2;
      }
    });
  },
  data() {
    return {
      form: {
        ParkLotId: "",
        PlateNumber: "",
        PlateColor: 1,
        ParkLotGateId: "",
        ParkLotGateUuid: "",
        reason: "",
        Direction: 1,
        OutGateId: "",
        Remark: "",
        CarSize: 1,
        PassTime: 0,
        AbnormalType: 3,
        Source: 2,
      },
      plateColorArr: ["蓝色", "黄色", "白色", "黑色", "新能源"],
      ParkLotGateUuidList: [
        {
          id: 0,
          value: "入口车道1",
        },
        {
          id: 1,
          value: "入口车道2",
        },
      ],
      panelShow: false,
      panelText: "",
      ParkLotGateId: "",
      rules: {
        PlateNumber: [
          { required: false, trigger: "blur", message: "请输入车牌号" },
        ],
        ParkLotGateUuid: [
          { required: true, trigger: "blur", message: "请选择开闸车道" },
        ],
        // reason: [{ required: true, trigger: "change" ,message:"请输入开闸原因"}],
      },
      noPlateNumber: false,
      statusOptions: [],
      isDisabled: false,
      dialogPlateVisible: false,
    };
  },
  methods: {
    handleClick() {
      this.isDisabled = true;
      this.$refs.form.validate(async (valid) => {
        if (valid || this.noPlateNumber) {
          this.form.PlateColor = this.form.PlateNumber.length > 7 ? 5 : 1;
          this.form.ParkLotId = this.ParkLotId;
          this.form.ParkLotGateId = Number(this.form.ParkLotGateId);
          this.form.OutGateId = Number(this.form.OutGateId);
          this.form.AbnormalType = this.titleDialog === '强制入车' ? 3 : 2;
          let res = await openGate(this.form);
          if (res.state === "success") {
            this.$message.success(res.message);
            this.isDisabled = false;
            eventPubSub.publish("");
            this.$emit("update:showdialog", false);
          } else {
            this.$message.error(res.message);
            this.isDisabled = false;
          }
        } else {
          console.log("error submit!!");
          this.isDisabled = false;
          return false;
        }
      });
    },
    handleClose() {
      this.$refs["form"].resetFields();
      this.$emit("update:showdialog", false);
    },
    getPlateNumber(v) {
      this.form.PlateNumber = v.value;
      this.$refs["form"].clearValidate();
    },
    getReason(reason) {
      this.form.reason = reason;
    },
    getItem(item) {
      this.form.ParkLotGateUuid = item.Uuid;
      this.form.ParkLotGateId = item.Id;
      this.form.OutGateId = item.Id;
    },
    async outPassType() {
      let res = await outPassType();
      if (res.state === "success") {
        this.statusOptions = res.data;
        this.form.AbnormalType = this.statusOptions[0].Id;
      } else {
        this.$message.error(res.message);
      }
    },
    getCarSize(obj) {
      this.form.CarSize = obj.value
    },
    handleCheck() {
      if (this.noPlateNumber) {
        this.form.PlateNumber = '';
        this.dialogPlateVisible = false;
      }
    },
  },
};
</script>

